import React from 'react';

const ModalContentAstHelpText = React.createClass({
    render() {
        return (
            <div>
                <p>
                    An assured shorthold tenancy (AST) agreement is the most commonly used tenancy agreement when
                    a private landlord lets residential property. Most new tenancies are automatically this type.
                    A tenancy can be an AST if all the following apply:
                </p>
                <ul>
                    <li>you’re a private landlord or housing association</li>
                    <li>the tenancy started on or after 15 January 1989</li>
                    <li>the property is your tenants’ main accommodation</li>
                    <li>you don’t live in the property</li>
                </ul>
                <p>
                    If you have any questions, please call us on 0800 038 4574. If you’re
                    still unsure here are some useful links:
                </p>
                <ul>
                    <li><a target="_blank" className="underline primary-colour" href="https://www.gov.uk/tenancy-agreements-a-guide-for-landlords/what-you-should-include-in-a-tenancy-agreement">What you should include in a tenancy agreement?</a></li>
                    <li><a target="_blank" className="underline primary-colour" href="https://www.gov.uk/tenancy-agreements-a-guide-for-landlords/overview">Tenancy agreements: a guide for landlords (England and Wales)</a></li>
                </ul>
            </div>
        );
    }
});

export default ModalContentAstHelpText;



/** WEBPACK FOOTER **
 ** ./src/components/Modals/Content/ModalContentAstHelpText.js
 **/